import { render } from "./Index.vue?vue&type=template&id=4b154f7c&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=4b154f7c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4b154f7c"

export default script